import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'unicon-btn-vertical-menu',
  templateUrl: './btn-vertical-menu.component.html',
})
export class BtnVerticalMenuComponent {
  @Input() closingProbability: boolean = false;
  @Output() action: EventEmitter<string> = new EventEmitter<string>();
  /* @Output() updateClosingProbability: EventEmitter<number> =
    new EventEmitter<number>(); */

  protected stopPropagation(event: MouseEvent): void {
    event.stopImmediatePropagation();
  }

  protected executeAction(action: string): void {
    this.action.emit(action);
  }
}
